var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { VehicleBuilder } from '../builders/vehicle-builder';
import { PointBuilder } from '../builders/point-builder';
import { AdminClientBuilder } from "../builders/adminClient-builder";
import { AdminProfileBuilder } from '../builders/admin-profile-builder';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class AdminClientsApiService {
    constructor(authenticatedApi) {
        this.authenticatedApi = authenticatedApi;
    }
    listClientsAdmin(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.get(`/adminclient/list`, payload).toPromise();
            return AdminClientBuilder.buildAdminClientsList(response);
        });
    }
    search(query, page = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = { query, page };
            const { clients } = yield this.authenticatedApi.get(`/adminclient/search`, payload).toPromise();
            return clients.map(client => AdminClientBuilder.buildAdminClient(client));
        });
    }
    getAdminClient(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const { client } = yield this.authenticatedApi.get(`/adminclient/${id}`).toPromise();
            return AdminClientBuilder.buildAdminClient(client);
        });
    }
    listClientVehicles(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const { client: { vehicles } } = yield this.authenticatedApi.get(`/adminclient/${id}`).toPromise();
            return vehicles.map(vehicle => VehicleBuilder.buildVehicle(vehicle));
        });
    }
    addClientVehicle(id, vehicle) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post(`/adminclient/add_vehicle/${id}`, vehicle).toPromise();
            return VehicleBuilder.buildVehicle(response.vehicle);
        });
    }
    updateClientVehicle(clientID, vehicleID, vehicle) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.put(`/adminclient/update_vehicle/${clientID}/${vehicleID}`, vehicle).toPromise();
            return VehicleBuilder.buildVehicle(response.vehicle);
        });
    }
    getAdminInvoiceProfile(profileID) {
        return __awaiter(this, void 0, void 0, function* () {
            const invoice = yield this.authenticatedApi.get(`/adminclient/profile/${profileID}`).toPromise();
            return AdminProfileBuilder.buildAdminProfile(invoice);
        });
    }
    getClientPoints(id, date) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.get(`/adminclient/point/${id}/${date}`).toPromise();
            return response;
        });
    }
    listClientPoints(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.get(`/adminclient/list_points/${id}`).toPromise();
            return _.map(response.points, (points) => {
                return PointBuilder.buildPoint(points);
            });
        });
    }
    addClientPoints(point) {
        return __awaiter(this, void 0, void 0, function* () {
            let payload = {
                id_client: point.id_client,
                date: point.date,
                points: point.points
            };
            const response = yield this.authenticatedApi.post(`/adminclient/point/${point.id_client}`, JSON.stringify(payload)).toPromise();
            return response.status;
        });
    }
    updateClientPoints(date, modifiedPoint) {
        return __awaiter(this, void 0, void 0, function* () {
            let payload = {
                date: modifiedPoint.date,
                points: modifiedPoint.points
            };
            const response = yield this.authenticatedApi.put(`/adminclient/point/${modifiedPoint.id_client}/${date}`, JSON.stringify(payload)).toPromise();
            return response;
        });
    }
    deleteClientPoints(point) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.delete(`/adminclient/point/${point.id_client}/${point.date}`).toPromise();
            return response;
        });
    }
    updateAdminClient(adminClient) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.put(`/adminclient/${adminClient.id}`, JSON.stringify(adminClient)).toPromise();
            return AdminClientBuilder.buildAdminClient(response.client);
        });
    }
    createAdminClient(adminClient) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.post('/adminclient', JSON.stringify(adminClient)).toPromise();
            return response;
        });
    }
    listEmailReport(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.get('/adminclient/email_report', payload).toPromise();
            return response;
        });
    }
    createAdminClientNote(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.post('/adminclient/note', payload).toPromise();
            return response;
        });
    }
    deleteAdminClientNote(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authenticatedApi.delete(`/adminclient/note/${id}`).toPromise();
            return response;
        });
    }
    deleteAdminClient(id_client, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.authenticatedApi.post(`/adminclient/eraseclientdata/${id_client}`, payload).toPromise();
            return response;
        });
    }
}
AdminClientsApiService.ɵfac = function AdminClientsApiService_Factory(t) { return new (t || AdminClientsApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
AdminClientsApiService.ɵprov = i0.ɵɵdefineInjectable({ token: AdminClientsApiService, factory: AdminClientsApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(AdminClientsApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=admin-clients-api.service.js.map